import {
  RewardBanner,
  RewardBannerFormValues,
  RewardBannerPrizeType,
  RewardBannerButtonAction,
} from './types/RewardBannerTypes';
import { REWARDS_PROMO_TYPE_KEY } from '../../utils/promotionUtils';

export { REWARDS_PROMO_TYPE_KEY };

function createEmptyPrize() {
  return {
    prizeType: RewardBannerPrizeType.None,
    prizeValue: '',
  };
}

export function createEmptyRewardBannerFormValues(): RewardBannerFormValues {
  return {
    title: '',
    description: '',
    label: '',
    priority: 1,
    buttonText: '',
    specialRequirements: '',
    buttonAction: RewardBannerButtonAction.Story,
    buttonTarget: '',
    prize: createEmptyPrize(),
    active: false,
    imageUrl: '',
    cardImageUrl: '',
    detailImageUrl: '',
    ringColor: '',
    ringColorTouched: false,
    removeCardImage: false,
    removeModalImage: false,
  };
}

export function rewardBannerToFormValues(rewardBanner: RewardBanner): RewardBannerFormValues {
  let prize = createEmptyPrize();
  if (rewardBanner.prize) {
    try {
      prize = JSON.parse(rewardBanner.prize);
    } catch {
      prize = createEmptyPrize();
    }
  }

  return {
    id: rewardBanner.id,
    title: rewardBanner.title,
    description: rewardBanner.description,
    label: rewardBanner.label || '',
    priority: rewardBanner.priority,
    buttonText: rewardBanner.buttonText,
    specialRequirements: rewardBanner.specialRequirements || '',
    buttonAction: rewardBanner.buttonAction,
    buttonTarget: rewardBanner.buttonTarget || '',
    prize,
    active: rewardBanner.active,
    imageUrl: rewardBanner.imageUrl,
    // The GET omits these optional fields when the event has no custom artwork/colour.
    // Fresh intent flags are essential on edit: absent multipart fields mean leave unchanged.
    cardImageUrl: rewardBanner.cardImageUrl ?? '',
    detailImageUrl: rewardBanner.detailImageUrl ?? '',
    ringColor: rewardBanner.ringColor ?? '',
    ringColorTouched: false,
    removeCardImage: false,
    removeModalImage: false,
  };
}

export function createRewardBannerFormData(values: RewardBannerFormValues) {
  const formData = new FormData();
  formData.append('title', values.title);
  formData.append('description', values.description);
  formData.append('label', values.label);
  formData.append('priority', String(values.priority));
  formData.append('buttonText', values.buttonText);
  formData.append('specialRequirements', values.specialRequirements);
  formData.append('buttonAction', values.buttonAction);
  formData.append('buttonTarget', values.buttonTarget);
  formData.append('prize', JSON.stringify(values.prize));
  formData.append('active', values.active ? 'true' : 'false');
  if (values.newCoverImage) {
    formData.append('image', values.newCoverImage.file, values.newCoverImage.fileName);
  } else if (values.imageUrl) {
    formData.append('imageUrl', values.imageUrl);
  }

  // Card icon, modal cover and ring colour follow the /events multipart contract.
  // A removal deliberately wins over a pending file so this builder cannot create
  // the server-rejected upload+remove combination even if called outside the form.
  if (values.newCardImage && !values.removeCardImage) {
    formData.append('cardImage', values.newCardImage.file, values.newCardImage.fileName);
  }
  if (values.newModalImage && !values.removeModalImage) {
    formData.append('modalImage', values.newModalImage.file, values.newModalImage.fileName);
  }
  if (values.removeCardImage) {
    formData.append('removeCardImage', '1');
  }
  if (values.removeModalImage) {
    formData.append('removeModalImage', '1');
  }
  if (values.ringColorTouched) {
    formData.append('ringColor', values.ringColor);
  }
  return formData;
}
